import { useEffect } from "react"

export const usePostMessage = <T = any>(type: string, data?: T, onComplete?: () => void) => {
  useEffect(() => {
    const channel = new BroadcastChannel(type)
    channel.postMessage(data)
    onComplete?.()
    return () => channel.close()
  }, [])
}

export const useOnMessage = <T = object>(
  channelName: string,
  onMessage: (event: MessageEvent<T>) => void,
) => {
  useEffect(() => {
    const channel = new BroadcastChannel(channelName)
    channel.addEventListener("message", onMessage)
    return () => {
      channel.removeEventListener("message", onMessage)
      channel.close()
    }
  }, [channelName, onMessage])
}
